import React, { useEffect, useState } from 'react';
import RichTextComposer from '../RichTextComposer/RichTextComposerTiptap';
import styles from './FactionMemberNoteModal.module.css';

const FactionMemberNoteModal = ({
  open,
  title,
  initialValue = '',
  saving = false,
  onClose,
  onSave,
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (open) {
      setValue(initialValue || '');
    }
  }, [open, initialValue]);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKey = (event) => {
      if (event.key === 'Escape' && !saving) {
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, saving, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div className={styles.overlay} onClick={() => !saving && onClose()} role="presentation">
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="faction-member-note-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.header}>
          <h2 id="faction-member-note-title" className={styles.title}>{title}</h2>
          <button type="button" className={styles.closeBtn} onClick={() => !saving && onClose()} aria-label="Fermer">
            ×
          </button>
        </div>
        <div className={styles.body}>
          <p className={styles.hint}>
            Informations spécifiques à la faction (rôle, historique, notes internes…).
          </p>
          <div className={styles.editor}>
            <RichTextComposer value={value} onChange={setValue} />
          </div>
        </div>
        <div className={styles.footer}>
          <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={saving}>
            Annuler
          </button>
          <button type="button" className={styles.saveBtn} onClick={() => onSave(value)} disabled={saving}>
            {saving ? 'Enregistrement…' : 'Enregistrer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FactionMemberNoteModal;
